const doc = [({"en":({"js":({"layout":({"require_two_factor_authentication_proxy":({"please_set_up_two_factor_authentication":"Please set up two-factor authentication."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;